module.exports = __webpack_public_path__ + "static/img/repast_3.a1ed307c.jpg";